import React from "react";
import UpperHeader from "./UpperHeader";
import StickyHeader from "./StickyHeader";

const Header = () => {
  return (
    <>
      <div className="page-wrapper">
        <header className="header w-100"  style={{backgroundColor:"white",top:"0px"}}>
          
          <UpperHeader />
          {/* <!-- End .header-top --> */}
          <StickyHeader />
          {/* <!-- End .header-bottom --> */}
        
        </header>
        {/* <!-- End .header --> */}
      </div>
     

      
    </>
  );
};

export default Header;
